module.exports = __webpack_public_path__ + "img/sweden-congenital-and-perinatal-diseases-female.4b313c24.png";